// extracted by mini-css-extract-plugin
export default {"container":"MapInfo_container__bhgRZ","coord":"MapInfo_coord__exfOh","scale":"MapInfo_scale__15kYK"};